module.exports = __webpack_public_path__ + "img/fc_logo.96f62176.png";